/** Capitalize a string
 * @param { string } s the string to capitalize
 */
export function capitalize(s: string): string | null {
  if (!s || !s.length) {
    return null
  }

  return s && s[0].toUpperCase() + s.slice(1)
}
